import React from "react"
import { CountBadge } from "../count-badge"
import { Icon } from "../icon"
import type { IconName } from "../icon/assets/icon-map"
import { Tabs } from "../tabs-new"
import type { TabsTabProps } from "../tabs-new"

// =============================================================================
// Props
// =============================================================================

export type PageSecondaryHeaderTabProps = {
  /**
   * Optional count rendered in a `CountBadge` after `children`.
   */
  count?: number
  /**
   * Optional icon rendered before `children`.
   */
  icon?: IconName
} & TabsTabProps

// =============================================================================
// Component
// =============================================================================

/**
 * Secondary page header tab. A `Tabs.Tab`, rendered as a
 * `<button role="tab">` and selected when its `value` matches the ancestor
 * `PageSecondaryHeader.TabsRoot`'s value.
 *
 * Must be a descendant of `PageSecondaryHeader.Tabs`.
 */
export const PageSecondaryHeaderTab = React.forwardRef<
  HTMLButtonElement,
  PageSecondaryHeaderTabProps
>(function PageSecondaryHeaderTab({ children, count, icon, ...props }, ref) {
  return (
    <Tabs.Tab ref={ref} {...props}>
      {/* Keeps the icon out of the label's sibling list, so toggling it never
          inserts before text a page translator has replaced. */}
      <span className="contents">{icon && <Icon name={icon} size="xs" />}</span>
      {children}
      {count !== undefined && <CountBadge count={count} />}
    </Tabs.Tab>
  )
})
